import Button from './button/button.vue'
import Alert from './alert/alert.vue'
import Switch from './switch/switch.vue'
import Dialog from './dialog/dialog.vue'
import Headline from './headline/headline.vue'
import './font.less'
const ui = {
  install(vue){
    vue.component('MyButton',Button)
    vue.component('MyAlert',Alert)
    vue.component('MySwitch',Switch)
    vue.component('MyDialog',Dialog)
    vue.component('MyHeadline',Headline)
  }
}
export default ui